import React from 'react'
import { Result } from 'antd'
import { useServerContext } from 'next-server-context'

import CtaButton from 'components/CtaButton/CtaButton'
import Link from 'components/Link/Link'

export default function NotFound({
  title,
  subTitle,
  backButtonText,
  backButtonHref,
}) {
  const serverContext = useServerContext()

  if (serverContext) serverContext.response.statusCode = 404

  return (
    <Result
      status="404"
      title={title}
      subTitle={subTitle}
      extra={
        <Link href={backButtonHref}>
          <a>
            <CtaButton
              type="primary"
              style={{
                whiteSpace: 'normal',
                height: 'auto',
              }}
            >
              {backButtonText}
            </CtaButton>
          </a>
        </Link>
      }
    />
  )
}
